function normalizePersonalCodeNumber(x) {
    if (!x) {
        return null;
    }
    x = x.replace(/-/g, '');
    x = x.replace(/\s/g, '');
    if (x.length == 10) {
        if (Number(x[2]) < 2) {
            //Assume the person is born in the 2000's. If the date is greater than
            //current date, subtract 100 years from PCN. This gives us the correct 1900's PCN.
            var xDate = Date.newFull("20"+x.substring(0,2) + "-" + Number(x.substring(2,4) - 1) + "-" + x.substring(4,6));  
            //if the PCN date is not possible in the 2000's, convert to 1900's.
            x = (xDate.isFutureDate() ? x = "19" + x : x = "20" + x);

        }
    }

    return x;
}

function isValidPersonalCode(x) {
    x = normalizePersonalCodeNumber(x);
    if (!x || x.length != 12 || isNaN(x)) {
        return false;
    }

    var year = x.substring(0, 4);
    var month = x.substring(4, 6);
    var day = x.substring(6, 8);
    if (year < 1900 || year > 2099 || month > 12 || day > 31) {
        return false;
    }

    var sum = 0;
    for (var i=2; i < 11; ++i) {
        var factor = (i%2) == 0 ? 2 : 1;
        var d = Number(x[i]);
        var c = d * factor;
        sum += Math.floor(c / 10) + (c % 10);
    }

    var controlCode = 10 - (sum % 10);
    if (controlCode == 10) {
        controlCode = 0;
    }

    return Number(x[9+2]) == controlCode;
}

function isValidMail(mail) {
    if(!mail) {return false;}
    if(!mail.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {return false;}
    if (mail.match('[åäöÅÄÖ]')) { return false; }
    return true;
}

function addThousandDelimiter(nStr, delimiter) {
    if (delimiter == undefined) {
        delimiter = ' ';
    }
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + delimiter + '$2');
    }
    return x1 + x2;
}

function isString(x) {
    return typeof x === 'string' || x instanceof String;
}

function formatPrice(x) {
    if (x == undefined || x == null) {
        return "";
    }

    if (!isString(x)) {
        x = String(x);
    }
    x = x.replace(',', '.');
    x = String(Number(x).toFixed(2));

    var parts = x.split('.');
    var decimals = null;
    if (parts.length == 2) {
        var ds = Number('0.' + parts[1]).toFixed(2).substring(2);
        var d = Number(ds);
        if (d) {
            decimals = ds;
        }
    }

    x = addThousandDelimiter(parts[0]) + (decimals ? ',' + decimals : '');
    return x + ' kr';
}

function isValidPath(x) {
    if (x.startsWith('/')) {
        x = x.substring(1);
    }
    return /^[a-z0-9-._~/]*$/.test(x);
}

function makeValidPathFromTitle(title) {
    let tmp = title.toLowerCase().replace(/\s/g, '-').replace(/[åä]/g, 'a').replace(/ö/g, 'o');
    return '/' + tmp.split('').filter(isValidPath).join('');
}

function decodeJson2(data, deep) {
    deep = deep || 99;
    if(deep < 1) {
        console.warn('Recursion is detected');
        return data;
    }
    if(data == null) {return null;}
    if(typeof(data) !== 'object') {
        return data;
    }
    if(window.Blob && data instanceof window.Blob) {
        return data;
    }

    if(data.$datetime) {
        var d = data.$datetime.match(/^(\d{4})-(\d\d)-(\d\d) (\d\d):(\d\d):(\d\d)$/);
        return new Date(d[1], d[2]-1, d[3], d[4], d[5], d[6]);
    }

    if(data.$date) {
        let d = data.$date.match(/^(\d{4})-(\d\d)-(\d\d)$/);
        return new Date(d[1], d[2]-1, d[3]);
    }

    if(data.$decimal) {
        return parseFloat(data.$decimal);
    }

    /*if(data.$link) {
        return new Link(data);
    }*/

    if(Array.isArray(data)) {
        let result = new Array(data.length);
        for(let i=0;i<data.length;i++) {
            result[i] = decodeJson2(data[i], deep-1);
        }
        return result;
    }

    let result = {};
    for(var key in data) {
        result[key] = decodeJson2(data[key], deep-1);
    }
    return result;
}

function getName(x) {
    return x && (x.name || (x.firstname ? (x.firstname + ' ' + x.lastname) : x.lastname));
}

import {unescape, isObject} from 'lodash';
function stripHtml(x) {
    return x && unescape(x.replace(/<(?!br\s*\/?)[^>]+>/gi, ' ')).replaceAll('&#10;', ' ').replaceAll('&#13;', ' ');
}

function setCookie(name,value,days,setSamSite) {
    var expires = "";
    if (days) {
        // Worth noting: As of Chrome release M104 (August 2022) cookies can no longer set an expiration date more than 400 days in the future.
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    let samesite = setSamSite ? ';SameSite=None; Secure;' : '';
    document.cookie = name + "=" + (value || "")  + expires + "; path=/" + samesite;
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function mergeBaskets(list) {
    let res = [];
    list.forEach(r => {
        Object.keys(r.basket).forEach(product_id => {
            let b = r.basket[product_id];
            b.forEach(bi => {
                if (bi.count) {
                    let ri = res.find(i => i.product_id == product_id && i.variant == bi.variant);
                    if (!ri) {
                        ri = {product_id, variant: bi.variant, count: 0}
                        res.push(ri);
                    }
                    ri.count += bi.count;
                }
            })
        })
    })
    return res;
}

const DAY_PERIODS = [
    {id: 'earlymorning', title: 'Early morning', icon: 'mdi-weather-sunset-up', start: 0, end: 7, short: 'early morning', color: '#61839a', backgroundColor: '#e6eff5' },
    {id: 'morning', title: 'Morning', icon: 'mdi-weather-sunny', start: 7, end: 12, short: 'morning', color: '#61839a', backgroundColor: '#e6eff5' },
    {id: 'afternoon', title: 'Afternoon', icon: 'mdi-weather-sunset-down', start: 12, end: 18, short: 'afternoon', color: '#bb7933', backgroundColor: '#f2ece5'},
    {id: 'night', title: 'Evening', icon: 'mdi-weather-night', start: 18, end: 24, short: 'evening', color: '#000', backgroundColor: '#eee'}
];

function getRandomId(length=64) {
    return '0'.repeat(length).replace(/0/g,function(){return (~~(Math.random()*16)).toString(16)});
}

function addOrUpdateStyle(styleId, style) {
    let styleElement = document.getElementById(styleId);
    if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.setAttribute('id', styleId);          
        styleElement.innerHTML = style;
        document.body.appendChild(styleElement)
    } else {
        styleElement.innerHTML = style;
    }
}

const TIMEUNITS = [{id: 'day', name: 'Days'}, {id: 'hour', name: 'Hours'}, {id: 'week', name: 'Weeks'}, {id: 'month', name: 'Months'}];
const TIMEUNITS_SINGULAR = [{id: 'day', name: 'Day'}, {id: 'hour', name: 'Hour'}, {id: 'week', name: 'Week'}, {id: 'month', name: 'Month'}];
const RELATIVE = [{id: 'beforestart', name: 'Before start'}, {id: 'afterstart', name: 'After start'}];

class RelativeTime {
    constructor(obj) {
        this.value = obj.value;
        this.timeunit = this.value == 1 ? TIMEUNITS_SINGULAR.find(x => x.id == obj.timeunit) : TIMEUNITS.find(x => x.id == obj.timeunit);
        this.relative = RELATIVE.find(x => x.id == obj.relative);
    }

    get hours() {
        let t = this.timeunit.id;
        let m = 1;
        if (t == 'day') {
            m = 24;
        } else if (t == 'week') {
            m = 7 * 24;
        } else if (t == 'month') {
            m = 30 * 24;
        }

        return this.value * m;
    }

    getDate(date) {
        let ms = this.hours*60*60*1000;
        date = Date.newFull(date).clone();
        if (this.relative.id == 'beforestart') {
            date.setTime(date.getTime() - ms);
        } else if (this.relative.id == 'afterstart') {
            date.setTime(date.getTime() + ms);
        }

        return date;
    }

    get string() {
        let t = window.$translate;
        return `${this.value} ${t(this.timeunit.name).toLowerCase()} ${t(this.relative.name).toLowerCase()}`;
    }
}

function getAgeFromPersonalCodeNumber(pcode) {
    if (!pcode || pcode.length < 8) {
        return null;
    }

    pcode = normalizePersonalCodeNumber(pcode);
    let yyyy = pcode.substring(0, 4);
    let mm = pcode.substring(4, 4+2);
    let dd = pcode.substring(6, 6+2);
    return Date.getAge(`${yyyy}-${mm}-${dd}`);
}

function getPriceString(product) {
    let res = formatPrice(product.price);
    if (!product.priceType || product.priceType == 'OneTime') {
        return res;
    } else {
        res += ' per ' + window.$translate(product.priceType).toLowerCase();
        return res;
    }
}

function getCartPriceString(cart) {
    let pts = {};
    cart.forEach(i => {
        let pt = i.product?.priceType || 'OneTime';
        let price = i.count * (i.product?.price || i.price);
        if (!pts[pt]) {
            pts[pt] = 0;
        }
        pts[pt] += price;
    })
    const t = window.$translate;

    let res = [];
    if (pts['OneTime']) {
        res.push(formatPrice(pts['OneTime']))
    }
    if (pts['Month']) {
        res.push(formatPrice(pts['Month']) + ' ' + t('per month'))
    }
    if (pts['Year']) {
        res.push(formatPrice(pts['Year']) + ' ' + t('per year'))
    }
    if (pts['HalfYear']) {
        res.push(formatPrice(pts['HalfYear']) + ' ' + t('per half year'))
    }
    if (pts['Quarter']) {
        res.push(formatPrice(pts['Quarter']) + ' ' + t('per quarter'))
    }
    if (pts['Week']) {
        res.push(formatPrice(pts['Week']) + ' ' + t('per week'))
    }
    if (pts['Day']) {
        res.push(formatPrice(pts['Day']) + ' ' + t('per day'))
    }

    return res.join(', ');
}

function getStockForProduct(product, variant, siteId) {
    if (product.variants) {
        variant = product.variants.find(v => v.name == variant)
        if (!variant) {
            return undefined;
        }

        let ss = variant?.stock_sites.find(x => x.site_id == siteId);
        if (!ss) {
            return undefined;
        }

        return ss.stock;
    }

    return product.stock;
}

function isSafari() {
    let safari = !!window.Blob.prototype.fakeBlob;
    if (!safari) {
        var ua = navigator.userAgent.toLowerCase(); 
        if (ua.indexOf('safari') != -1) { 
            safari = ua.indexOf('chrome') < 0;
        }
    }
    
    return safari;
}

function arrayBufferToBase64( buffer ) {
    var binary = '';
    var bytes = new Uint8Array( buffer );
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
        binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
}

function serverDownload(input) {
    var fd, contentType;
    if(input.blob.fakeBlob) {
        contentType = input.blob.option.type;
        fd = new FormData();
        fd.append('file', arrayBufferToBase64(input.blob.data[0]));
        fd.append('filetype', 'base64');
    } else {
        contentType = input.blob.type;
        fd = new FormData();
        fd.append('file', input.blob);
        //fd.append('filename', input.filename);
    }

    window.$zoeziapi.post('/api/utils/serverdownloader/save', fd).then(response => {
        response.json().then(data => {
            document.location.href = '/api/utils/serverdownloader/load?secret=' + data.secret + '&type=' + encodeURIComponent(contentType) + '&filename=' + encodeURIComponent(input.filename);
        });
    });
}

function downloadFile({filename, blob, data, type}) {
    const newBlob = blob || new Blob([data], { type: type || 'application/octet-stream' });

    if (isSafari()) {
        return serverDownload({blob: newBlob, filename})
    }

    const objUrl = window.URL.createObjectURL(newBlob);

    let link = document.createElement('a');
    link.href = objUrl;
    link.download = filename;
    link.click();

    // For Firefox it is necessary to delay revoking the ObjectURL.
    setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
}

function isMobile() {
    return /Android|iP(hone|od)|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

function isExpoApp() {
    return window.isExpoApp;
}

function appHandlesAppleSignin() {
    return window.appleSigninNative;
}

function initExpo() {
    if (!isExpoApp()) { return; }
    window.setAcceptTrackingCookies = function(accept) {
        window.$vue.$emit('setThirdpartyCookieStatus', accept);
    };
    window.expo = {};
}

function setRootProps(config) {
    if (config.root && config.root.props) {
        Object.keys(config.root.props).forEach(key => {
            let value = config.root.props[key];
            const noCopy = ['colors'];
            if (value !== undefined && !noCopy.includes(key)) {
                config[key] = value;
            }
        })
    }
}

function removeSearchParamater(key) {
    const url = new URLSearchParams(window.location.search);
    url.delete(key);
    const queryString = url.toString();
    const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
    window.history.replaceState({}, '', newUrl);
}

function getUrlParameterThis(name) {
    name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let q = window.location.href;
    if (q.indexOf('?') != -1) {
        let results = regex.exec('?' + q.split('?')[1]);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
}

function isInIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

function applyTemplateSettings(config, settings) {
    let findComponent = (x, id) => {
        if (Array.isArray(x)) {
            for (let i=0; i < x.length; ++i) {
                let f = findComponent(x[i], id)
                if (f) {
                    return f;
                }
            }
        } else if (isObject(x)) {
            if (x.id == id) {
                return x;
            }
            let values = Object.values(x);
            for (let i=0; i < values.length; ++i) {
                let f = findComponent(values[i], id);
                if (f) {
                    return f;
                }
            }
        }
    }

    Object.keys(settings).forEach(key => {
        let id = key.split('-')[0];
        let prop = key.substring(id.length+1);
        let value = settings[key];
        let c = findComponent(config, id);
        if (c) {
            let tsprops = c.templateSettings?.props;
            let tprop = tsprops.find(p => p.id == prop);
            if (tprop) {
                c.props[prop] = value
            }
        }
    })
}

function getCartItems(cartName) {
    const $store = window.$store;
    if ($store.state.carts && $store.state.carts[cartName] && $store.state.carts[cartName].items) {
        return $store.state.carts[cartName].items;
    }

    return [];
}

function resultRules(resultType) {
    const validationRules = {
        'HHMMSS': {
            pattern: /^(?:[0-1]?[0-9]|2[0-3])\.[0-5][0-9]\.[0-5][0-9]$/,
            errorMessage: getResultTypeErrorMessage("Time (hours, minutes, seconds)", "01.23.45")
        },
        'MMSS': {
            pattern: /^[0-5]?[0-9]\.[0-5][0-9]$/,
            errorMessage: getResultTypeErrorMessage("Time (minutes, seconds)", "01.23")
        },
        'SSss': {
            pattern: /^[0-9]+(\.[0-9]+)?$/,
            errorMessage: getResultTypeErrorMessage("Time (seconds, hundreds)", "01.23")
        },
        'SSsss': {
            pattern: /^[0-9]+(\.[0-9]{3})?$/,
            errorMessage: getResultTypeErrorMessage("Time (seconds, thousands)", "01.234")
        },
        'number': {
            pattern: /^[0-9]+$/,
            errorMessage: getResultTypeErrorMessage("Positive integer")
        },
        'pdecimal': {
            pattern: /^[0-9]+(\.[0-9]+)?$/,
            errorMessage: getResultTypeErrorMessage("Positive decimal", "1.23")
        },
        'integer': {
            pattern: /^-?[0-9]+$/,
            errorMessage: getResultTypeErrorMessage("Integer")
        },
        'decimal': {
            pattern: /^-?[0-9]+(\.[0-9]+)?$/,
            errorMessage: getResultTypeErrorMessage("Decimal", "1.23")
        }
    };

    const rule = validationRules[resultType] || {};
    const pattern = rule.pattern || /.*/;
    const errorMessage = rule.errorMessage || window.$translate('Invalid input');

    return [
        value => {
            if (value === '' || value == null) {
                return true;
            }
            return pattern.test(value) || errorMessage;
        }
    ];
}

function getResultTypeErrorMessage(resultType, example) {
    return example
        ? window.$translate('Allowed format: {0}, Ex: {1}').format(window.$translate(resultType), example)
        : window.$translate('Allowed format: {0}').format(window.$translate(resultType));
   
}

export {isValidPersonalCode, isValidMail, formatPrice, isValidPath, makeValidPathFromTitle, decodeJson2, getName, stripHtml,
    setCookie, getCookie, eraseCookie, normalizePersonalCodeNumber, getRandomId, addOrUpdateStyle, mergeBaskets, getAgeFromPersonalCodeNumber, DAY_PERIODS, RelativeTime,
    getPriceString, getCartPriceString, getStockForProduct, downloadFile, isMobile, isExpoApp, initExpo, setRootProps, getUrlParameterThis, isInIframe, isString, applyTemplateSettings,
    getCartItems, appHandlesAppleSignin, removeSearchParamater, resultRules
};
